import { render, staticRenderFns } from "./NoticeServiceTable.vue?vue&type=template&id=670c83d2&"
import script from "./NoticeServiceTable.vue?vue&type=script&lang=ts&"
export * from "./NoticeServiceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports